import {B1_FRONT_TEXTURE_ONE_EDITION} from '../utils/static.utils.js'
export default class CardPattern{
    id;
    name;
    path;
    constructor({name, path, id, ...data}){
        this.name = name
        this.path = path
        this.id = id
    }
}


export const ONE_EDITION_PATTERN = new CardPattern({
    name: "one edition",
    path: B1_FRONT_TEXTURE_ONE_EDITION
})

